import { cn } from "@/lib/utils";
import { BasicTooltip } from "./ui/Tooltip";

const ProgressBar = ({
  isLoading,
  progress,
  failedTooltipText,
  successTooltipText,
}: {
  isLoading: boolean;
  progress: number;
  failedTooltipText?: string;
  successTooltipText?: string;
}) => (
  <div
    className={`relative w-full max-w-[200px] ${
      isLoading ? "animate-pulse" : ""
    }`}
  >
    <BasicTooltip
      shouldShow={Boolean(!isLoading && failedTooltipText)}
      content={failedTooltipText}
    >
      <div
        style={{
          width: `calc(100% - ${progress}%)`,
        }}
        className={cn(
          "ml-auto flex h-2 overflow-hidden rounded rounded-l-none text-xs",
          isLoading ? "bg-blue-200" : "bg-red-400",
          progress === 0 && "rounded-l",
        )}
      />
    </BasicTooltip>
    <BasicTooltip
      shouldShow={Boolean(successTooltipText)}
      content={successTooltipText}
    >
      <div
        style={{
          width: `${progress}%`,
        }}
        className={cn(
          "absolute left-0 top-0 flex h-2 flex-col justify-center whitespace-nowrap rounded rounded-r-none text-center text-white shadow-none",
          isLoading ? "bg-blue-500" : "bg-green-400",
          progress === 100 && "rounded-r",
        )}
      />
    </BasicTooltip>
  </div>
);

export default ProgressBar;
